exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-expansion-panel-header{border-radius:0}.v-expansion-panel:before{box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}", ""]);

// exports
